import PropTypes from 'prop-types';
import React from 'react';
import TabClick from 'modules/common/TabClick';

const OutputCode = ({outputContent}) => (
  <div>
    <TabClick
      isOutput
      title={
        <div className="mr2">
          <h4>Output</h4>
        </div>
      }>
      <div className="bg-near-white">{outputContent}</div>
    </TabClick>
  </div>
);

OutputCode.propTypes = {
  outputContent: PropTypes.node.isRequired,
};

export default OutputCode;
